import React, { useEffect } from 'react';

const ImagePreviewModal = (props) => {
  const { images, previewModal, setPreviewModal, currentSlide, setCurrentSlide, baseUrl } = props

  useEffect(() => {
    if(currentSlide > images?.length) {
      setCurrentSlide(1)
    } else if(currentSlide < 1) {
      setCurrentSlide(images?.length)
    }
  }, [currentSlide, images])
  

  return (
    <div className={previewModal ? "prev-img-modal open-modal" : "prev-img-modal"}>
      <span className="close" onClick={() => setPreviewModal(false)}>&times;</span>
      <div className="slide-indicator">{currentSlide} / {images?.length}</div>
      <div className="modal-content">
        {images?.map((item, index) => 
          <div key={index} className={((index + 1) === currentSlide) ? "prev-img-slides display-slide" : "prev-img-slides"}>
            <img src={`${baseUrl}/${item}`} alt={`Slide ${index}`} />
          </div>
        )}
        <a className="prev" onClick={() => setCurrentSlide(currentSlide - 1)}>&#10094;</a>
        <a className="next" onClick={() => setCurrentSlide(currentSlide + 1)}>&#10095;</a>
      </div>
    </div>
  )
}

export default ImagePreviewModal;